var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.104,
    height: 41.482,
    viewBox: "0 0 47.104 41.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd8321"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M5317.79,1030.864v6.636a9.314,9.314,0,0,1-.45,1.294,3.988,3.988,0,0,1-3.608,2.3c-.872.033-1.748.017-2.621,0a.471.471,0,0,0-.513.324,17.734,17.734,0,0,1-11.879,10.169c-.292.08-.341.214-.344.477a15.321,15.321,0,0,1-.082,2.2,4.087,4.087,0,0,1-4.349,3.413,4.171,4.171,0,0,1-3.833-3.865,4.106,4.106,0,0,1,3.395-4.328c.979-.156,1.986-.129,2.97-.271a15.2,15.2,0,1,0-17.248-17.22,16.3,16.3,0,0,0,.8,7.664c.148.435.281.875.417,1.314.009.026-.011.059-.024.125-1.248,0-2.5.007-3.757,0a17.194,17.194,0,0,1-2.521-.081,4.055,4.055,0,0,1-3.441-4.055q-.023-2.763,0-5.529a4.14,4.14,0,0,1,4.156-4.155c.78-.008,1.563-.022,2.344.008a.616.616,0,0,0,.679-.436,17.884,17.884,0,0,1,32.645-.082.74.74,0,0,0,.809.522,19.828,19.828,0,0,1,2.936.064,4.005,4.005,0,0,1,3.438,3.255A2.468,2.468,0,0,0,5317.79,1030.864Z",
    transform: "translate(-5270.686 -1016.204)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M5386.1,1072.439a12.418,12.418,0,1,0-22.364,8.59.7.7,0,0,1,.053.866,2.836,2.836,0,0,1-2.433,1.5v2.744h.352c4.063,0,8.125.028,12.186-.01A12.412,12.412,0,0,0,5386.1,1072.439Zm-16.522,2.635h-2.685v-2.723h2.685Zm5.52-.023h-2.7v-2.707h2.7Zm5.548,0h-2.719v-2.69h2.719Z",
    transform: "translate(-5350.2 -1055.721)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatIcon);
export default __webpack_public_path__ + "static/media/Live_Chat_icon.c3bc63fe.svg";
export { ForwardRef as ReactComponent };